import { keyBy } from "lodash";

import { Tag } from "@livechat/design-system-icons";

import { ITag } from "store/entities/tags";

import { IFilterConfig, IFilterLabelValue } from "../interfaces";

const title = "Tag";
export const tagFilterConfigMultiple: IFilterConfig = {
  title,
  icon: Tag,
  mobileViewTitle: "Select tags",
  multiple: true,
  getFilterLabelValues: (
    filterValues: string[] | null,
    tags: ITag[],
    _: unknown,
    allTags?: ITag[]
  ): IFilterLabelValue[] => {
    if (filterValues === null) {
      return [];
    }

    const tagsMap = keyBy(tags, tag => tag.id);

    const allTagsMap = allTags ? keyBy(allTags, tag => tag.id) : {};

    return filterValues.reduce((acc: IFilterLabelValue[], tagId) => {
      if (tagsMap[tagId]) {
        return [...acc, { key: tagId, label: tagsMap[tagId].name }];
      }
      const removedLabel = allTagsMap[tagId] ? `${title} unavailable` : `${title} removed`;
      return [...acc, { key: tagId, label: removedLabel, invalid: true }];
    }, []);
  },
};
